<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               {{year}} © ITURRIAPP.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Desarrollado por DESPACHOS ADUANEROS CHAVIMOCHIC
                </div>
            </div>
        </div>
    </div>
</footer>
